import React from 'react';
import styled from 'styled-components';
import {
  PolymorphicComponent,
  solvSystem,
  SolvSystemProps,
  sx,
  WithSx,
} from '../../theme/system';
import { style } from '../../utils/css';
import BaseClickable, {
  BaseClickableProps,
} from '../BaseClickable/BaseClickable';

type IconButtonProps = SolvSystemProps &
  WithSx &
  PolymorphicComponent &
  BaseClickableProps;

const IconButtonBase = styled(BaseClickable)<IconButtonProps>(
  style({
    '&&': {
      p: 2,
      borderRadius: 'full',
      transition: 'background .15s',
      ':hover': {
        bg: 'gray-100',
      },
      ':active': {
        bg: 'gray-200',
      },
    },
  }),
  solvSystem,
  sx,
);

const IconButton = ({ children, ...props }: IconButtonProps) => {
  return <IconButtonBase {...props}>{children}</IconButtonBase>;
};

export default IconButton;
